import { createSvgComponent } from "../../icon/createSvgComponent";
import LikeFill from "@core/__generated__/icon/figma/like-fill.svg";
export default createSvgComponent(LikeFill);